import { mapState } from "vuex";
export const queueIndexMixins = {
  computed: {
    queueTopBarList() {
        let topbarList = [
            {
                name: "排队取号",
                isActive: false,
                path: "/queue",
                icon:require("@/assets/img/menuIcons/icon-queue.png")
            },
            {
                name: "就餐预订",
                isActive: false,
                path: "/queue/reserve",
                icon:require("@/assets/img/menuIcons/icon-queuereserve.png")
            }
        ];
        topbarList.forEach(val => {
            if (val.path == this.$route.path) {
                val.isActive = true;
            }
        });
        return topbarList;
    }
  },
}
